import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PaymentModal from './PaymentModal';

interface CheckoutProps {
  open: boolean;
  onClose: () => void;
}

export default function Checkout({ open, onClose }: CheckoutProps) {
  const navigate = useNavigate();
  const [invoiceId, setInvoiceId] = useState<string | null>(null);

  function handleSuccess(id: string) {
    setInvoiceId(id);
  }

  if (invoiceId) {
    return (
      <div className="checkout-success">
        <div className="checkout-success__card">
          <div className="checkout-success__icon"><i className="fa fa-check-circle" /></div>
          <h2>Payment Complete</h2>
          <p>Invoice #{invoiceId}</p>
          <div className="checkout-success__actions">
            <button
              className="btn btn--outline"
              onClick={() => navigate(`/invoices/${invoiceId}`)}
            >
              View Invoice
            </button>
            <button
              className="btn btn--primary"
              onClick={() => {
                setInvoiceId(null);
                onClose();
              }}
            >
              New Sale
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <PaymentModal
      open={open}
      onClose={onClose}
      onSuccess={handleSuccess}
    />
  );
}
